var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"max-height":"50px","src":require('@/assets/SideBarBG.png'),"gradient":"to right, #ffffff 0%, #336699 100%"}},[_c('v-breadcrumbs',{attrs:{"items":_vm.items,"divider":"-"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }